module.exports = __webpack_public_path__ + "static/media/48275554_2308778865863958_5747631613257187328_o.ffc2899d.jpg";